import Vue from 'vue'
import Router from 'vue-router'
// 页面路由
const Login = () => import('@/pages/Login')
const VehicleHome = () => import('@/pages/VehicleHome')
const Navigation = () => import('@/pages/Navigation')
// 子页面路由--------车辆管理
const vehicleState = () => import('@/pages/VehicleManagement/index')
const vehicleSite = () => import('@/pages/VehicleManagement/vehicleSite')
const vehicleTask = () => import('@/pages/VehicleManagement/vehicleTask')
const vehicleRoute = ()=>import('@/pages/VehicleManagement/vehicleRoute')
const vehicleTrigger = ()=>import('@/pages/VehicleManagement/vehicleTrigger')
const vehicleHistorical = ()=>import('@/pages/VehicleManagement/vehicleHistorical')

// 子页面路由--------气象监测
const environment = () => import('@/pages/Environment/index')
const environmentSite = ()=> import('@/pages/Environment/environmentSite')
const environmentData = ()=> import('@/pages/Environment/environmentData')
// 子页面路由--------气体监测
const gas = () => import('@/pages/Gas/index')
const gasSite = ()=> import('@/pages/Gas/gasSite')
const gasData = ()=> import('@/pages/Gas/gasData')
// 子页面路由--------水质监测
const waterQuality = () => import('@/pages/WaterQuality/index')
const waterQualitySite = ()=> import('@/pages/WaterQuality/waterQualitySite')
const waterQualityData = ()=> import('@/pages/WaterQuality/waterQualityData')
// 子页面路由--------视频监控
const videomonitor = ()=> import('@/pages/Video/videomonitor')
const videospare = ()=> import('@/pages/Video/videospare')
// 子页面路由--------平台告警
// const alarmstrategy = ()=> import('@/pages/Platformalarm/alarmstrategy')
const messagepush = ()=> import('@/pages/Platformalarm/messagepush')
const alarmrecord = ()=> import('@/pages/Platformalarm/alarmrecord')
// 子页面路由--------人员管理
const information = ()=> import('@/pages/Management/information')
const group = ()=> import('@/pages/Management/group')
// 子页面路由--------历史热图
const historyMap = ()=> import('@/pages/HistoryMap/index')
const automatic =()=> import('@/pages/HistoryMap/automatic')

Vue.use(Router)

const router = new Router({

	routes: [{
			path: '*',
			redirect: '/Login'
		}, {
			path: '/Login',
			name: 'Login',
			component: Login
		},
		{
			path: '/VehicleHome',
			name: 'VehicleHome',
			component: VehicleHome,
		},
		{
			path: '/Navigation',
			name: 'Navigation',
			component: Navigation,
			redirect: '/Navigation/vehicleState',
			children: [{
					path: 'vehicleState',
					name: 'vehicleState',
					component: vehicleState
				},
				{
					path: 'vehicleSite',
					name: 'vehicleSite',
					component: vehicleSite
				},
				{
				  path:'vehicleTask',
				  name:'vehicleTask',
				  component:vehicleTask
				},
				{
				  path:'vehicleRoute',
				  name:'vehicleRoute',
				  component:vehicleRoute
				},
				{
				  path:'vehicleTrigger',
				  name:'vehicleTrigger',
				  component:vehicleTrigger
				},
				{
				  path:'vehicleHistorical',
				  name:'vehicleHistorical',
				  component:vehicleHistorical
				}
			]
		},
		{
			path: '/Environment',
			name: 'Environment',
			component: Navigation,
			redirect: '/Environment/environment',
			children: [{
					path: 'environment',
					name: 'environment',
					component: environment
				},
				{
				  path:'environmentSite',
				  name:'environmentSite',
				  component:environmentSite
				},
				{
				  path:'environmentData',
				  name:'environmentData',
				  component:environmentData
				},
			]
		},
		{
			path: '/Gas',
			name: 'Gas',
			component: Navigation,
			redirect: '/Gas/gas',
			children: [{
					path: 'gas',
					name: 'gas',
					component: gas
				},
				{
				  path:'gasSite',
				  name:'gasSite',
				  component:gasSite
				},
				{
				  path:'gasData',
				  name:'gasData',
				  component:gasData
				},
			]
		},
		{
			path: '/WaterQuality',
			name: 'WaterQuality',
			component: Navigation,
			redirect: '/WaterQuality/waterQuality',
			children: [{
					path: 'waterQuality',
					name: 'waterQuality',
					component: waterQuality
				},
				{
				  path:'waterQualitySite',
				  name:'waterQualitySite',
				  component:waterQualitySite
				},
				{
				  path:'waterQualityData',
				  name:'waterQualityData',
				  component:waterQualityData
				},
			]
		},
		{
			path: '/Video',
			name: 'Video',
			component: Navigation,
			redirect: '/Video/videomonitor',
			children: [{
					path: 'videomonitor',
					name: 'videomonitor',
					component: videomonitor
				},
				{
				  path:'videospare',
				  name:'videospare',
				  component:videospare
				},
			]
		},
		{
			path: '/Platformalarm',
			name: 'Platformalarm',
			component: Navigation,
			redirect: '/Platformalarm/messagepush',
			children: [
				{
				  path:'messagepush',
				  name:'messagepush',
				  component:messagepush
				},
				{
				  path:'alarmrecord',
				  name:'alarmrecord',
				  component:alarmrecord
				},
			]
		},
		{
			path: '/Management',
			name: 'Management',
			component: Navigation,
			redirect: '/Management/information',
			children: [{
					path: 'information',
					name: 'information',
					component: information
				},
				{
				  path:'group',
				  name:'group',
				  component:group
				},
			]
		},
		{
			path: '/HistoryMap',
			name: 'HistoryMap',
			component: Navigation,
			redirect: '/HistoryMap/historyMap',
			children: [{
					path: 'historyMap',
					name: 'historyMap',
					component: historyMap
				},
				{
				  path:'automatic',
				  name:'automatic',
				  component:automatic
				},
			]
		},
	]
})


// const routerPush = router.prototype.push
// router.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error => error)
// }
export default router
